export const UPDATE_VEHICLE_DETAILS_EMPLOYEE = "UPDATE_VEHICLE_DETAILS_EMPLOYEE";
export const UPDATE_VEHICLE_DETAILS_EMPLOYEE_SUCCESS = "UPDATE_VEHICLE_DETAILS_EMPLOYEE_SUCCESS";
export const UPDATE_VEHICLE_DETAILS_EMPLOYEE_FAIL = "UPDATE_VEHICLE_DETAILS_EMPLOYEE_FAIL";

export const STAFF_GET_EVENTS = "STAFF_GET_EVENTS";
export const STAFF_GET_EVENTS_SUCCESS = "STAFF_GET_EVENTS_SUCCESS";
export const STAFF_GET_EVENTS_FAIL = "STAFF_GET_EVENTS_FAIL";

export const REFINE_TEXT = "REFINE_TEXT";
export const REFINE_TEXT_SUCCESS = "REFINE_TEXT_SUCCESS";
export const REFINE_TEXT_FAIL = "REFINE_TEXT_FAIL";

export const SWITCH_ACCOUNT = "SWITCH_ACCOUNT";
export const SWITCH_ACCOUNT_SUCCESS = "SWITCH_ACCOUNT_SUCCESS";
export const SWITCH_ACCOUNT_FAIL = "SWITCH_ACCOUNT_FAIL";

export const REMOVE_EMP_SWITCH_ACCOUNT = "REMOVE_EMP_SWITCH_ACCOUNT";
export const REMOVE_EMP_SWITCH_ACCOUNT_SUCCESS = "REMOVE_EMP_SWITCH_ACCOUNT_SUCCESS";
export const REMOVE_EMP_SWITCH_ACCOUNT_FAIL = "REMOVE_EMP_SWITCH_ACCOUNT_FAIL";

export const STAFF_PART_DETAILS = "STAFF_PART_DETAILS";
export const STAFF_PART_DETAILS_SUCCESS = "STAFF_PART_DETAILS_SUCCESS";
export const STAFF_PART_DETAILS_FAIL = "STAFF_PART_DETAILS_FAIL";

export const SERVICE_PROGRESS_NOTE = "SERVICE_PROGRESS_NOTE";
export const SERVICE_PROGRESS_NOTE_SUCCESS = "SERVICE_PROGRESS_NOTE_SUCCESS";
export const SERVICE_PROGRESS_NOTE_FAIL = "SERVICE_PROGRESS_NOTE_FAIL";

export const SERVICE_ITEM_DETAILS = "SERVICE_ITEM_DETAILS";
export const SERVICE_ITEM_DETAILS_SUCCESS = "SERVICE_ITEM_DETAILS_SUCCESS";
export const SERVICE_ITEM_DETAILS_FAIL = "SERVICE_ITEM_DETAILS_FAIL";

export const LOGOUT_STAFF = "LOGOUT_STAFF";
export const LOGOUT_STAFF_SUCCESS = "LOGOUT_STAFF_SUCCESS";
export const LOGOUT_STAFF_FAIL = "LOGOUT_STAFF_FAIL";

export const STAFF_TASK_ID = "STAFF_TASK_ID";
export const STAFF_TASK_ID_SUCCESS = "STAFF_TASK_ID_SUCCESS";
export const STAFF_TASK_ID_FAIL = "STAFF_TASK_ID_FAIL";

export const GET_NOTE_BY_ID = "GET_NOTE_BY_ID";
export const GET_NOTE_BY_ID_SUCCESS = "GET_NOTE_BY_ID_SUCCESS";
export const GET_NOTE_BY_ID_FAIL = "GET_NOTE_BY_ID_FAIL";

export const UPDATE_STAFF_PRO_NOTE = "UPDATE_STAFF_PRO_NOTE";
export const UPDATE_STAFF_PRO_NOTE_SUCCESS = "UPDATE_STAFF_PRO_NOTE_SUCCESS";
export const UPDATE_STAFF_PRO_NOTE_FAIL = "UPDATE_STAFF_PRO_NOTE_FAIL";

export const POST_CLOCK_IN_TIME = "POST_CLOCK_IN_TIME";
export const POST_CLOCK_IN_TIME_SUCCESS = "POST_CLOCK_IN_TIME_SUCCESS";
export const POST_CLOCK_IN_TIME_FAIL = "POST_CLOCK_IN_TIME_FAIL";

export const POST_TIMMINGS = "POST_TIMMINGS";
export const POST_TIMMINGS_SUCCESS = "POST_TIMMINGS_SUCCESS";
export const POST_TIMMINGS_FAIL = "POST_TIMMINGS_FAIL";

export const STAFF_ACTION = "STAFF_ACTION";
export const STAFF_ACTION_SUCCESS = "STAFF_ACTION_SUCCESS";
export const STAFF_ACTION_FAIL = "STAFF_ACTION_FAIL";

export const SUBMIT_INICIDENT_REPORT = "SUBMIT_INICIDENT_REPORT";
export const SUBMIT_INICIDENT_REPORT_SUCCESS = "SUBMIT_INICIDENT_REPORT_SUCCESS";
export const SUBMIT_INICIDENT_REPORT_FAIL = "SUBMIT_INICIDENT_REPORT_FAIL";

export const SET_TASK_TIMEOUT = "SET_TASK_TIMEOUT";
export const SET_TASK_TIMEOUT_SUCCESS = "SET_TASK_TIMEOUT_SUCCESS";
export const SET_TASK_TIMEOUT_FAIL = "SET_TASK_TIMEOUT_FAIL";

export const SHOW_MODAL = "SHOW_MODAL";
export const HIDE_MODAL = "HIDE_MODAL";

export const SUBMITION_APPROVAL = "SUBMITION_APPROVAL";
export const SUBMITION_APPROVAL_SUCCESS = "SUBMITION_APPROVAL_SUCCESS";
export const SUBMITION_APPROVAL_FAIL = "SUBMITION_APPROVAL_FAIL";

export const NOTES_BY_ADMIN = "NOTES_BY_ADMIN";
export const NOTES_BY_ADMIN_SUCCESS = "NOTES_BY_ADMIN_SUCCESS";
export const NOTES_BY_ADMIN_FAIL = "NOTES_BY_ADMIN_FAIL";

export const GET_EMPLOYEE_PROFILE_DETAILS = "GET_EMPLOYEE_PROFILE_DETAILS";
export const GET_EMPLOYEE_PROFILE_DETAILS_SUCCESS = "GET_EMPLOYEE_PROFILE_DETAILS_SUCCESS";
export const GET_EMPLOYEE_PROFILE_DETAILS_FAIL = "GET_EMPLOYEE_PROFILE_DETAILS_FAIL";

export const SEND_ATTACHMENTS_BY_EMPLOYEE = "SEND_ATTACHMENTS_BY_EMPLOYEE";
export const SEND_ATTACHMENTS_BY_EMPLOYEE_SUCCESS = "SEND_ATTACHMENTS_BY_EMPLOYEE_SUCCESS";
export const SEND_ATTACHMENTS_BY_EMPLOYEE_FAIL = "SEND_ATTACHMENTS_BY_EMPLOYEE_FAIL";

export const UPLOAD_REQ_DOCS = "UPLOAD_REQ_DOCS";
export const UPLOAD_REQ_DOCS_SUCCESS = "UPLOAD_REQ_DOCS_SUCCESS";
export const UPLOAD_REQ_DOCS_FAIL = "UPLOAD_REQ_DOCS_FAIL";

export const UPLOAD_STAFF_CERTIFICATE_DOCS = "UPLOAD_STAFF_CERTIFICATE_DOCS";
export const UPLOAD_STAFF_CERTIFICATE_DOCS_SUCCESS = "UPLOAD_STAFF_CERTIFICATE_DOCS_SUCCESS";
export const UPLOAD_STAFF_CERTIFICATE_DOCS_FAIL = "UPLOAD_STAFF_CERTIFICATE_DOCS_FAIL";

export const GET_DOCUMENTS_STATUS_LIST = "GET_DOCUMENTS_STATUS_LIST";
export const GET_DOCUMENTS_STATUS_LIST_SUCCESS = "GET_DOCUMENTS_STATUS_LIST_SUCCESS";
export const GET_DOCUMENTS_STATUS_LIST_FAIL = "GET_DOCUMENTS_STATUS_LIST_FAIL";

export const GET_TRAININGS_STAFF = "GET_TRAININGS_STAFF";
export const GET_TRAININGS_STAFF_SUCCESS = "GET_TRAININGS_STAFF_SUCCESS";
export const GET_TRAININGS_STAFF_FAIL = "GET_TRAININGS_STAFF_FAIL";

export const GET_INICIDENT_FORM_QUESTIONS = "GET_INICIDENT_FORM_QUESTIONS";
export const GET_INICIDENT_FORM_QUESTIONS_SUCCESS = "GET_INICIDENT_FORM_QUESTIONS_SUCCESS";
export const GET_INICIDENT_FORM_QUESTIONS_FAIL = "GET_INICIDENT_FORM_QUESTIONS_FAIL";

export const SUBMIT_INCIDENT_FORM_EMPLOYEE = "SUBMIT_INCIDENT_FORM_EMPLOYEE";
export const SUBMIT_INCIDENT_FORM_EMPLOYEE_SUCCESS = "SUBMIT_INCIDENT_FORM_EMPLOYEE_SUCCESS";
export const SUBMIT_INCIDENT_FORM_EMPLOYEE_FAIL = "SUBMIT_INCIDENT_FORM_EMPLOYEE_FAIL";

export const GET_POLICY_FOR_EMPLOYEE = "GET_POLICY_FOR_EMPLOYEE";
export const GET_POLICY_FOR_EMPLOYEE_SUCCESS = "GET_POLICY_FOR_EMPLOYEE_SUCCESS";
export const GET_POLICY_FOR_EMPLOYEE_FAIL = "GET_POLICY_FOR_EMPLOYEE_FAIL";

export const CONFIRM_TRAINING_TERMS = "CONFIRM_TRAINING_TERMS";
export const CONFIRM_TRAINING_TERMS_SUCCESS = "CONFIRM_TRAINING_TERMS_SUCCESS";
export const CONFIRM_TRAINING_TERMS_FAIL = "CONFIRM_TRAINING_TERMS_FAIL";

export const HIT_DOWNLOAD = "HIT_DOWNLOAD";
export const HIT_DOWNLOAD_SUCCESS = "HIT_DOWNLOAD_SUCCESS";
export const HIT_DOWNLOAD_FAIL = "HIT_DOWNLOAD_FAIL";

export const GET_MY_SHIFTS = "GET_MY_SHIFTS";
export const GET_MY_SHIFTS_SUCCESS = "GET_MY_SHIFTS_SUCCESS";
export const GET_MY_SHIFTS_FAIL = "GET_MY_SHIFTS_FAIL";

export const EMP_GET_FOLDERS = "EMP_GET_FOLDERS";
export const EMP_GET_FOLDERS_SUCCESS = "EMP_GET_FOLDERS_SUCCESS";
export const EMP_GET_FOLDERS_FAIL = "EMP_GET_FOLDERS_FAIL";

export const EMP_GET_FOLDER_FILES = "EMP_GET_FOLDER_FILES";
export const EMP_GET_FOLDER_FILES_SUCCESS = "EMP_GET_FOLDER_FILES_SUCCESS";
export const EMP_GET_FOLDER_FILES_FAIL = "EMP_GET_FOLDER_FILES_FAIL";

export const EMP_ADD_FILE_TO_FOLDER = "EMP_ADD_FILE_TO_FOLDER";
export const EMP_ADD_FILE_TO_FOLDER_SUCCESS = "EMP_ADD_FILE_TO_FOLDER_SUCCESS";
export const EMP_ADD_FILE_TO_FOLDER_FAIL = "EMP_ADD_FILE_TO_FOLDER_FAIL";

export const START_EMP_SHIFT = "START_EMP_SHIFT";
export const START_EMP_SHIFT_SUCCESS = "START_EMP_SHIFT_SUCCESS";
export const START_EMP_SHIFT_FAIL = "START_EMP_SHIFT_FAIL";

export const END_EMP_SHIFT = "END_EMP_SHIFT";
export const END_EMP_SHIFT_SUCCESS = "END_EMP_SHIFT_SUCCESS";
export const END_EMP_SHIFT_FAIL = "END_EMP_SHIFT_FAIL";

export const EMP_AVAILABILITY = "EMP_AVAILABILITY";
export const EMP_AVAILABILITY_SUCCESS = "EMP_AVAILABILITY_SUCCESS";
export const EMP_AVAILABILITY_FAIL = "EMP_AVAILABILITY_FAIL";

export const EMP_ADD_AVAILABILITY = "EMP_ADD_AVAILABILITY";
export const EMP_ADD_AVAILABILITY_SUCCESS = "EMP_ADD_AVAILABILITY_SUCCESS";
export const EMP_ADD_AVAILABILITY_FAIL = "EMP_ADD_AVAILABILITY_FAIL";

export const EMP_UPDATE_AVAILABILITY = "EMP_UPDATE_AVAILABILITY";
export const EMP_UPDATE_AVAILABILITY_SUCCESS = "EMP_UPDATE_AVAILABILITY_SUCCESS";
export const EMP_UPDATE_AVAILABILITY_FAIL = "EMP_UPDATE_AVAILABILITY_FAIL";

export const EMP_GET_OPEN_SHIFTS = "EMP_GET_OPEN_SHIFTS";
export const EMP_GET_OPEN_SHIFTS_SUCCESS = "EMP_GET_OPEN_SHIFTS_SUCCESS";
export const EMP_GET_OPEN_SHIFTS_FAIL = "EMP_GET_OPEN_SHIFTS_FAIL";

export const REQUEST_OPEN_SHIFT = "REQUEST_OPEN_SHIFT";
export const REQUEST_OPEN_SHIFT_SUCCESS = "REQUEST_OPEN_SHIFT_SUCCESS";
export const REQUEST_OPEN_SHIFT_FAIL = "REQUEST_OPEN_SHIFT_FAIL";

export const CANCEL_OPEN_SHIFT = "CANCEL_OPEN_SHIFT";
export const CANCEL_OPEN_SHIFT_SUCCESS = "CANCEL_OPEN_SHIFT_SUCCESS";
export const CANCEL_OPEN_SHIFT_FAIL = "CANCEL_OPEN_SHIFT_FAIL";

export const GET_REQUESTED_OPEN_SHIFTS = "GET_REQUESTED_OPEN_SHIFTS";
export const GET_REQUESTED_OPEN_SHIFTS_SUCCESS = "GET_REQUESTED_OPEN_SHIFTS_SUCCESS";
export const GET_REQUESTED_OPEN_SHIFTS_FAIL = "GET_REQUESTED_OPEN_SHIFTS_FAIL";

export const USER_ACCOUNTS_LIST = "USER_ACCOUNTS_LIST";
export const USER_ACCOUNTS_LIST_SUCCESS = "USER_ACCOUNTS_LIST_SUCCESS";
export const USER_ACCOUNTS_LIST_FAIL = "USER_ACCOUNTS_LIST_FAIL";

export const GET_MEDICATION_DETAILS = "GET_MEDICATION_DETAILS";
export const GET_MEDICATION_DETAILS_SUCCESS = "GET_MEDICATION_DETAILS_SUCCESS";
export const GET_MEDICATION_DETAILS_FAIL = "GET_MEDICATION_DETAILS_FAIL";

export const SUBMIT_MED_REPORT = "SUBMIT_MED_REPORT";
export const SUBMIT_MED_REPORT_SUCCESS = "SUBMIT_MED_REPORT_SUCCESS";
export const SUBMIT_MED_REPORT_FAIL = "SUBMIT_MED_REPORT_FAIL";

export const GET_EMP_MEDICINE_LIST = "GET_EMP_MEDICINE_LIST";
export const GET_EMP_MEDICINE_LIST_SUCCESS = "GET_EMP_MEDICINE_LIST_SUCCESS";
export const GET_EMP_MEDICINE_LIST_FAIL = "GET_EMP_MEDICINE_LIST_FAIL";

export const GET_TODAYS_MEDICATION = "GET_TODAYS_MEDICATION";
export const GET_TODAYS_MEDICATION_SUCCESS = "GET_TODAYS_MEDICATION_SUCCESS";
export const GET_TODAYS_MEDICATION_FAIL = "GET_TODAYS_MEDICATION_FAIL";

export const EMP_SUBMIT_MEDICATION = "EMP_SUBMIT_MEDICATION";
export const EMP_SUBMIT_MEDICATION_SUCCESS = "EMP_SUBMIT_MEDICATION_SUCCESS";
export const EMP_SUBMIT_MEDICATION_FAIL = "EMP_SUBMIT_MEDICATION_FAIL";

export const EMP_MEDICATION_PRN = "EMP_MEDICATION_PRN";
export const EMP_MEDICATION_PRN_SUCCESS = "EMP_MEDICATION_PRN_SUCCESS";
export const EMP_MEDICATION_PRN_FAIL = "EMP_MEDICATION_PRN_FAIL";

export const SUBMIT_HAZARD_REPORT = "SUBMIT_HAZARD_REPORT";
export const SUBMIT_HAZARD_REPORT_SUCCESS = "SUBMIT_HAZARD_REPORT_SUCCESS";
export const SUBMIT_HAZARD_REPORT_FAIL = "SUBMIT_HAZARD_REPORT_FAIL";

export const SAVE_PROGRESS_NOTE = "SAVE_PROGRESS_NOTE";
export const SAVE_PROGRESS_NOTE_SUCCESS = "SAVE_PROGRESS_NOTE_SUCCESS";
export const SAVE_PROGRESS_NOTE_FAIL = "SAVE_PROGRESS_NOTE_FAIL";

export const GET_SUPPORT_WORKER_TIME_SHEETS = "GET_SUPPORT_WORKER_TIME_SHEETS";
export const GET_SUPPORT_WORKER_TIME_SHEETS_SUCCESS = "GET_SUPPORT_WORKER_TIME_SHEETS_SUCCESS";
export const GET_SUPPORT_WORKER_TIME_SHEETS_FAIL = "GET_SUPPORT_WORKER_TIME_SHEETS_FAIL";

export const SUBMIT_TIMESHEET_COMMENT = "SUBMIT_TIMESHEET_COMMENT";
export const SUBMIT_TIMESHEET_COMMENT_SUCCESS = "SUBMIT_TIMESHEET_COMMENT_SUCCESS";
export const SUBMIT_TIMESHEET_COMMENT_FAIL = "SUBMIT_TIMESHEET_COMMENT_FAIL";

export const AWAY_PARTICIPANT = "AWAY_PARTICIPANT";
export const AWAY_PARTICIPANT_SUCCESS = "AWAY_PARTICIPANT_SUCCESS";
export const AWAY_PARTICIPANT_ERROR = "AWAY_PARTICIPANT_ERROR";

export const SUBMIT_EMPLOYEE_COMPLAINT_FORM = "SUBMIT_EMPLOYEE_COMPLAINT_FORM";
export const SUBMIT_EMPLOYEE_COMPLAINT_FORM_SUCCESS = "SUBMIT_EMPLOYEE_COMPLAINT_FORM_SUCCESS";
export const SUBMIT_EMPLOYEE_COMPLAINT_FORM_FAIL = "SUBMIT_EMPLOYEE_COMPLAINT_FORM_FAIL";
